import { graphql } from '@api/mesa'

export const COMPLETE_PLAID_LINK = graphql(`
  mutation completePlaidLink($input: LinkSuccessInput!) {
    completePlaidLink(linkSuccessInput: $input) {
      status
    }
  }
`)
